import React from "react";
import tutifyLogo from "../../assets/images/tutifyLogo.png";
import fbIcon from "../../assets/images/facebook (2).png";
import twitterIcon from "../../assets/images/twitter (1).png";
import instagramIcon from "../../assets/images/instagram (2).png";
import linkedInIcon from "../../assets/images/linkedin (1).png";
import locationIcon from "../../assets/images/location.png";
import callIcon from "../../assets/images/call.png";
import mailIcon from "../../assets/images/mail.png";
const Footer = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const quickLinks = [
    {
      id: 1,
      name: "Home",
      url: "/",
    },
    {
      id: 2,
      name: "about",
      url: "/",
    },
    {
      id: 3,
      name: "blogs",
      url: "/",
    },
    {
      id: 4,
      name: "featured teacher",
      url: "/",
    },
    {
      id: 5,
      name: "course offer",
      url: "/",
    },
    {
      id: 6,
      name: "contact",
      url: "/",
    },
  ];
  const services = [
    {
      id: 1,
      name: "free learning",
      url: "/",
    },
    {
      id: 2,
      name: "scholerships",
      url: "/",
    },
    {
      id: 3,
      name: "community services",
      url: "/",
    },
    {
      id: 4,
      name: "become a teacher",
      url: "/",
    },
    {
      id: 5,
      name: "find a teacher",
      url: "/",
    },
  ];

  return (
    <div className="">
      <footer className="primary_dark_bg_color text-light pt-5 padd_left_right_40">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <div className="logo">
                <img width={150} src={tutifyLogo} alt="Tutify Logo" />
              </div>
              <p className="my-4 fs_14">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime
                mollitia, molestiae quas vel sint commodi repudiandae
                consequuntur voluptatum.
              </p>

              <div className="py-4">
                <a href="/">
                  <img width={25} className="me-2" src={fbIcon} alt="fb icon" />
                </a>
                <a href="/">
                  <img
                    width={25}
                    className="me-2"
                    src={twitterIcon}
                    alt="twitter Icon"
                  />
                </a>
                <a href="/">
                  <img
                    width={25}
                    className="me-2"
                    src={instagramIcon}
                    alt="instagram icon"
                  />
                </a>
                <a href="/">
                  <img
                    width={25}
                    className="me-2"
                    src={linkedInIcon}
                    alt="linkedIn Icon"
                  />
                </a>
              </div>
            </div>

            <div className="col-md-3 ps-lg-5">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Quick Links
              </h6>
              <ul className="list-unstyled">
                {quickLinks?.map((item) => {
                  return (
                    <li key={item?.id} className="my-1">
                      <a
                        href="/"
                        className="text-decoration-none text-white fs_12 text-uppercase"
                        to={item?.url}
                      >
                        {item?.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="col-md-3  ps-lg-5">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Services
              </h6>
              <ul className="list-unstyled">
                {services?.map((item) => {
                  return (
                    <li key={item?.id} className="my-1">
                      <a
                        href="/"
                        className="text-decoration-none text-white fs_12 text-uppercase"
                        to={item?.url}
                      >
                        {item?.name}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="col-md-3">
              <h6 className="mb-4 pt-2 text_skyBluez text-uppercase">
                Contact us
              </h6>
              <div className="pb-2">
                <img
                  width={10}
                  className="me-3"
                  src={locationIcon}
                  alt="location"
                />{" "}
                <a
                  className="fs_12 text-decoration-none text-white"
                  href="https://maps.google.com/?q=123 Main St, City"
                >
                  123 Main St, City
                </a>
              </div>
              <div className="pb-2">
                <img width={10} className="me-3" src={callIcon} alt="call" />{" "}
                <a
                  className="fs_12 text-decoration-none text-white"
                  href="tel:(123) 456-7890"
                >
                  (123) 456-7890
                </a>
              </div>
              <div>
                <img width={10} className="me-3" src={mailIcon} alt="mail" />{" "}
                <a
                  href="mailto:info@example.com"
                  className="fs_12 text-decoration-none text-white"
                >
                  info@example.com
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-between">
          <p className="fs_12">
            Copyright &#169; tutify.online {currentYear} All Rights Reserved
          </p>
          <p className="fs_12">Privacy Policy Terms of Services</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
